import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Session } from '@models/session';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { IconDirective } from '../../directives/icon.directive';

@Component({
  selector: 'lv-verify-token-error',
  templateUrl: 'verify-token-error.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslateModule, IconDirective]
})
export class VerifyTokenErrorComponent {
  @Input() session: Session;
  @Output() dismiss = new EventEmitter();

  done() {
    this.dismiss.emit();
  }

  tryAgain() {
    this.session.$error = null;
  }
}
